import { useAllBanners } from '@entities/Banners'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BannerCarousel } from '@widgets/banner-carousel'






export default function BannerGalleryBlock ({ payload }: BlockProps) {
  const { banners, loading } = useAllBanners({
    typeId: payload?.id as string || ''
  })

  if (!payload?.id) {
    return null
  }

  return (
    <div className={styles.root__banner}>
      <BannerCarousel
        banners={banners}
        loading={loading}
      />
    </div>
  )
}
